
// use this for dev
// const baseUrl= "http://localhost:8080/api"


// use this for production
const baseUrl= process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : 'https://rateavendor-node-backend-535316989564.us-central1.run.app/api'

export default baseUrl
